/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import { notify, notificationNotify, systemInformationNotify } from './Toastify';

export const Toast = (message, type) => notify(message, type);
export const NotificationToast = (message, type) => notificationNotify(message, type);
export const SystemInformationNotify = (message, type) => systemInformationNotify(message, type);

export default Toast;
